import { DialogActions, withStyles } from '@material-ui/core';

export default withStyles({
  root: {
    justifyContent: 'center',
  }
})(DialogActions);